<template>
  <div>
    <div id="loginback">
      <div id="login">

        <!-- שלב 1: טופס התחברות רגיל -->
        <form v-if="!showCodeStep" @submit.prevent="login">
          <input id="username" name="username" type="text" size="40" class="login_name" v-model="username"
            aria-required="true" aria-invalid="false" placeholder="שם משתמש (מספר הקו)" required>
          <input id="password" name="password" type="password" size="40" class="login_password" v-model="password"
            placeholder="סיסמא" required>

          <!-- בחירת שיטת אימות -->
          <div class="verify-method-label">קבל קוד אימות באמצעות:</div>
          <div class="verify-method-row">
            <label class="method-option" :class="{ active: verifyMethod === 'email' }">
              <input type="radio" v-model="verifyMethod" value="email" class="method-radio" />
              <span class="method-icon">✉️</span>
              <span class="method-text">אימייל</span>
            </label>
            <label class="method-option" :class="{ active: verifyMethod === 'call' }">
              <input type="radio" v-model="verifyMethod" value="call" class="method-radio" />
              <span class="method-icon">📞</span>
              <span class="method-text">שיחת טלפון</span>
            </label>
          </div>

          <input type="submit" :value="isAuthSubmitting ? 'מתחבר...' : 'הכנס'" class="login_submit"
            :disabled="isAuthSubmitting"><br>
        </form>

        <!-- שלב 2: הזנת קוד אימות -->
        <form v-else @submit.prevent="verifyCode">
          <div class="step-title">אימות דו-שלבי</div>
          <div class="step-description">
            <span v-if="verifyMethod === 'email'">נשלח קוד אימות לכתובת האימייל שלך.</span>
            <span v-else>תקבל שיחת טלפון עם קוד האימות בקרוב.</span>
            <br />אנא הזן את הקוד כדי להמשיך.
            <div v-if="sentTo" class="sent-to">
              <span v-if="verifyMethod === 'email'">נשלח אל: </span>
              <span v-else>יחויג אל: </span>
              <strong dir="ltr">{{ sentTo }}</strong>
            </div>
          </div>
          <div v-if="verifyMethod === 'call'" class="call-hint">
            <v-icon small class="call-hint-icon">mdi-information-outline</v-icon>
            הזן את <strong>6 הספרות האחרונות</strong> של מספר הטלפון שחייג אליך
          </div>

          <input id="verifyCode" name="verifyCode" type="text" size="25" class="login_name login_code"
            v-model="verificationCode" placeholder="קוד אימות (6 ספרות)" maxlength="6" autocomplete="one-time-code"
            required>

          <!-- Remember IP checkbox row -->
          <div class="remember-row">
            <div class="remember-right">
              <label class="remember-label">
                <input type="checkbox" v-model="rememberIp" class="remember-checkbox" />
                <span class="remember-text">זכור אותי 30 יום</span>
              </label>
            </div>
            <div class="tooltip-wrapper">
              <span class="info-icon">?</span>
              <div class="tooltip-box">
                כתובת ה-IP שלך תישמר ברשימה המאושרת למשך 30 יום.<br />
                בתקופה זו תוכל להתחבר ללא אימות דו-שלבי מאותה רשת.
              </div>
            </div>
          </div>

          <input type="submit" :value="isAuthSubmitting ? 'מאמת...' : 'אמת קוד'" class="login_submit"
            :disabled="isAuthSubmitting"><br>
          <div style="text-align: center; margin-top: 8px;">
            <span @click="backToLogin" class="Back" style="font-size: 0.95em; opacity: 0.8;">→ חזרה לדף ההתחברות</span>
          </div>
        </form>

        <div v-if="!showCodeStep" style="display: flex; justify-content: space-between; width: 95%;">
          <div><span @click="forgotPassword" class="Back">שכחת סיסמה?</span></div>
          <div><span @click="openRegister" class="Back">צור חשבון</span></div>
        </div>
        <input id="submitme" name="submitme" value="1" type="hidden">

      </div>
    </div>

    <div class="centered-text">
      <div id="foter">
        <span style="color: white; font-weight: bold; font-size: 40px; margin-left: 20px;">מערכת ניהול</span>
        <span style="color: #ffb91a; font-weight: bold; font-size: 40px; margin-left: 20px; display: block;">מה נשמע
          פון</span>
      </div>
    </div>

    <template>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="84" color="#0d2c6d"></v-progress-circular>
      </v-overlay>
    </template>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </div>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import { mapMutations } from 'vuex';

export default {

  components: { SnackBar },

  data: () => ({
    username: "",
    password: "",
    verificationCode: "",
    verifyMethod: "call",   // "email" | "call"
    rememberIp: false,
    showCodeStep: false,
    sentTo: "",
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    overlay: false,
    isAuthSubmitting: false,
  }),

  methods: {
    ...mapMutations(['TOGGLE_USER_DETAILS']),

    async login() {
      if (this.isAuthSubmitting) return;

      this.isAuthSubmitting = true;

      const lineNumber = this.username;
      const password = this.password;
      const verifyMethod = this.verifyMethod;

      this.overlay = true;
      let MyJSON = JSON.stringify({ lineNumber, password, verifyMethod });
      let api = process.env.VUE_APP_BASE_URL + "/auth/login";

      try {
        const response = await fetch(api, ApiServices.requestOptions("POST", MyJSON, ""));
        const jsonObject = await response.json();

        if (response.status >= 400) {
          this.showSnackBar("שגיאת התחברות: " + jsonObject.message, "red");
        } else if (response.status === 200) {
          if (jsonObject.token) {
            // IP ברשימה הלבנה — התחברות ישירה
            this.showSnackBar("התחברת בהצלחה!", "green");
            localStorage.setItem('token', jsonObject.token);
            this.TOGGLE_USER_DETAILS();
            this.$store.commit('SET_TIMEZONE', null);
            this.$router.replace({ name: "home" });
          } else {
            // נדרש אימות דו-שלבי
            this.showCodeStep = true;
            this.verificationCode = "";
            this.rememberIp = false;
            this.sentTo = jsonObject.sentTo || "";
            const msg = verifyMethod === 'email'
              ? "נשלח קוד אימות לאימייל שלך"
              : "תקבל שיחת טלפון עם הקוד בקרוב";
            this.showSnackBar(jsonObject.message || msg, "green");
          }
        } else {
          this.showSnackBar("שגיאת שרת", "red");
        }
      } catch (error) {
        this.overlay = false;
        this.showSnackBar("Error Login: " + error, "red");
      } finally {
        this.overlay = false;
        this.isAuthSubmitting = false;
      }
    },

    async verifyCode() {

      if (this.isAuthSubmitting) return;

      this.isAuthSubmitting = true;

      const lineNumber = this.username;
      const verificationCode = this.verificationCode;
      const rememberIp = this.rememberIp;

      this.overlay = true;
      let MyJSON = JSON.stringify({ lineNumber, verificationCode, rememberIp });
      let api = process.env.VUE_APP_BASE_URL + "/auth/verifyCode";

      try {
        const response = await fetch(api, ApiServices.requestOptions("POST", MyJSON, ""));
        const jsonObject = await response.json();

        if (response.status >= 400) {
          this.showSnackBar("קוד שגוי: " + jsonObject.message, "red");
        } else if (response.status === 200) {
          this.showSnackBar("התחברת בהצלחה!", "green");
          localStorage.setItem('token', jsonObject.token);
          this.TOGGLE_USER_DETAILS();
          this.$store.commit('SET_TIMEZONE', null);
          this.$router.replace({ name: "home" });
        } else {
          this.showSnackBar("שגיאת שרת", "red");
        }
      } catch (error) {
        this.overlay = false;
        this.showSnackBar("Error: " + error, "red");
      } finally {
        this.overlay = false;
        this.isAuthSubmitting = false;
      }
    },

    backToLogin() {
      this.showCodeStep = false;
      this.verificationCode = "";
      this.rememberIp = false;
    },

    async forgotPassword() {
      const lineNumber = this.username;
      if (!lineNumber) return this.showSnackBar("יש להזין שם משתמש", "red");

      this.overlay = true;
      let MyJSON = JSON.stringify({ lineNumber });
      let api = process.env.VUE_APP_BASE_URL + "/auth/forgotPassword";

      try {
        const response = await fetch(api, ApiServices.requestOptions("POST", MyJSON, ""));
        this.overlay = false;
        const jsonObject = await response.json();
        if (response.status >= 400) {
          this.showSnackBar("שגיאה: " + jsonObject.message, "red");
        } else if (response.status === 200) {
          this.showSnackBar("נשלח אליכם אימייל לאיפוס הסיסמה", "green");
        } else {
          this.showSnackBar("שגיאת שרת", "red");
        }
      } catch (error) {
        this.overlay = false;
        this.showSnackBar("Error: " + error, "red");
      }
    },

    openRegister() { this.$emit("openRegister"); },

    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },

    handleResize() { this.isResponsive = window.innerWidth <= 500; },

    handleEnterKeyOtp(event) {
      if (event.keyCode === 13) {
        this.showCodeStep ? this.verifyCode() : this.login();
      }
    },
  },

  watch: {
    $route() { document.title = 'Login | CLICK-CALL'; },
  },

  mounted() {
    document.title = 'Login | CLICK-CALL';
    if (window.innerWidth <= 500) this.isResponsive = true;
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('keydown', this.handleEnterKeyOtp);
    setTimeout(() => {
      const badge = document.querySelector('.grecaptcha-badge');
      if (badge) badge.style.visibility = 'visible';
    }, 500);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('keydown', this.handleEnterKeyOtp);
    const badge = document.querySelector('.grecaptcha-badge');
    if (badge) badge.style.visibility = 'hidden';
  },
}
</script>

<style scoped>
#login {
  width: 65%;
  margin: 4% auto;
  min-height: 40%;
}

div#loginback {
  background: linear-gradient(135deg, #0e3280 0%, #0a2357 100%) !important;
  min-height: 55%;
  position: relative;
  z-index: 99;
}

.login_name {
  font-family: heebo, arial !important;
  border: 0 none !important;
  text-align: right !important;
  padding: 3% 13% 3% 5% !important;
  font-size: 1.25em !important;
  width: 95% !important;
  margin-bottom: 3% !important;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-position: 100% -.9vh !important;
  border-radius: .4vw !important;
  background-color: white;
  background-image: url(@/assets/login/icon_u.png);
}

.login_code {
  text-align: center !important;
  letter-spacing: 6px !important;
  font-size: 1.5em !important;
  font-weight: 700 !important;
  background-image: none !important;
  padding: 3% 5% !important;
  margin-bottom: 3% !important;
}

.login_password {
  font-family: heebo, arial;
  border: 0 none;
  text-align: right;
  padding: 3% 13% 3% 5%;
  width: 95%;
  font-size: 1.25em;
  margin-bottom: 4%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 100% -.9vh;
  border-radius: .4vw;
  background-color: white;
  background-image: url(@/assets/login/icon_s.png);
}

.login_submit {
  font-family: heebo, arial;
  padding: 2%;
  background: #fdb721;
  width: 95%;
  font-size: 1.57em;
  margin-bottom: 2%;
  cursor: pointer;
  border: none;
  border-radius: .4vw;
}

.Back {
  text-align: right;
  direction: rtl;
  color: #fff;
  font-size: 1.11em;
  font-family: heebo, arial;
  margin: 1% 0%;
  cursor: pointer;
}

/* ===== Verify method selector ===== */
.verify-method-label {
  font-family: heebo, arial;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.9em;
  text-align: right;
  direction: rtl;
  margin-bottom: 8px;
  width: 95%;
}

.verify-method-row {
  display: flex;
  gap: 10px;
  width: 95%;
  margin-bottom: 5%;
  direction: rtl;
}

.method-option {
  display: flex;
  align-items: center;
  gap: 7px;
  flex: 1;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1.5px solid rgba(255, 255, 255, 0.25);
  border-radius: .4vw;
  padding: 8px 12px;
  transition: background-color 0.2s, border-color 0.2s;
  direction: rtl;
}

.method-option:hover {
  background-color: rgba(255, 255, 255, 0.18);
}

.method-option.active {
  background-color: rgba(253, 183, 33, 0.18);
  border-color: #ffb91a;
}

.method-radio {
  display: none;
}

.method-icon {
  font-size: 1.15em;
  flex-shrink: 0;
}

.method-text {
  font-family: heebo, arial;
  font-size: 0.95em;
  color: #fff;
  user-select: none;
}

.method-option.active .method-text {
  color: #ffb91a;
  font-weight: 700;
}

/* ===== Remember IP row ===== */
.remember-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 95%;
  margin-bottom: 5%;
  direction: rtl;
}

.remember-right {
  display: flex;
  align-items: center;
}

.remember-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.remember-checkbox {
  width: 17px;
  height: 17px;
  accent-color: #ffb91a;
  cursor: pointer;
  flex-shrink: 0;
}

.remember-text {
  font-family: heebo, arial;
  font-size: 1em;
  color: #fff;
  user-select: none;
}

/* ===== Tooltip ===== */
.tooltip-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 0.8em;
  font-weight: 700;
  font-family: heebo, arial;
  cursor: default;
  border: 1.5px solid rgba(255, 255, 255, 0.45);
  transition: background-color 0.2s, border-color 0.2s;
  user-select: none;
}

.info-icon:hover {
  background-color: rgba(255, 185, 26, 0.45);
  border-color: #ffb91a;
}

.tooltip-box {
  display: none;
  position: absolute;
  right: 28px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #0a2357;
  color: #fff;
  font-family: heebo, arial;
  font-size: 0.82em;
  line-height: 1.6;
  direction: rtl;
  text-align: right;
  padding: 10px 14px;
  border-radius: 8px;
  width: 220px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 185, 26, 0.3);
  z-index: 100;
  pointer-events: none;
}

.tooltip-box::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  border: 6px solid transparent;
  border-right-color: #0a2357;
}

.tooltip-wrapper:hover .tooltip-box {
  display: block;
}

/* ===== Step UI ===== */
.step-title {
  font-family: heebo, arial;
  color: #fff;
  font-size: 1.5em;
  font-weight: 800;
  text-align: right;
  margin-bottom: 6px;
  direction: rtl;
}

.step-description {
  font-family: heebo, arial;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.95em;
  text-align: right;
  direction: rtl;
  margin-bottom: 16px;
  line-height: 1.6;
}

.sent-to {
  margin-top: 6px;
  font-size: 0.92em;
  color: rgba(255, 255, 255, 0.65);
  direction: rtl;
  text-align: right;
}

.sent-to strong {
  color: #ffb91a;
  font-family: 'Courier New', monospace;
  letter-spacing: 1px;
}

.call-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  direction: rtl;
  background-color: rgba(255, 185, 26, 0.15);
  border: 1px solid rgba(255, 185, 26, 0.4);
  border-radius: .4vw;
  padding: 9px 12px;
  margin-bottom: 14px;
  font-family: heebo, arial;
  font-size: 0.88em;
  color: #fff;
  line-height: 1.5;
  width: 88%;
}

.call-hint-icon {
  color: #ffb91a !important;
  flex-shrink: 0;
}

/* ===== Footer ===== */
#foter {
  background-image: url("@/assets/footer.svg");
  background-size: 108% auto;
  background-repeat: no-repeat;
  width: 34%;
  height: 16vh;
  position: absolute;
  bottom: 2%;
  z-index: 0;
}

.centered-text {
  text-align: center;
}

/* ===== Responsive ===== */
@media only screen and (max-width: 998px) and (min-height: 600px) {
  #login {
    width: 85%;
  }

  #foter {
    width: 100%;
    position: absolute;
    bottom: 5%;
  }

  .tooltip-box {
    right: auto;
    left: 28px;
  }

  .tooltip-box::after {
    left: auto;
    right: 100%;
    border-right-color: transparent;
    border-left-color: #0a2357;
  }

  .method-option {
    border-radius: 6px;
  }
}

.notification {
  display: block;
  padding: 3% 13% 3% 5%;
  width: 76%;
  border-radius: .4vw;
  margin-bottom: 2vh;
}

/* hebrew */
@font-face {
  font-family: 'Heebo';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/heebo/v22/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EiSysd0mm_00.woff2) format('woff2');
  unicode-range: U+0590-05FF, U+200C-2010, U+20AA, U+25CC, U+FB1D-FB4F;
}

/* latin */
@font-face {
  font-family: 'Heebo';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/heebo/v22/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EiSysdUmm.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
</style>